package com.castly.shared.dto

import kotlinx.serialization.Serializable

@Serializable
data class IsbnLookupResult(
    val found: Boolean,
    val isbn13: String,
    val title: String? = null,
    val author: String? = null,
    val publisher: String? = null,
    val description: String? = null,
    val coverImageUrl: String? = null,
    val publicationDate: String? = null,
    val categories: List<String> = emptyList(),
    val language: String? = null
)
